module.exports = __webpack_public_path__ + "img/terroir-spiral-1.449f10d3.jpg";